import { useState } from 'react';

import { FORM_INPUTS, INITIAL_RESULTS } from './constants';

const useDensityCalculator = () => {
  const [method, setMethod] = useState('displacement');
  const [formInputs, setFormInputs] = useState(FORM_INPUTS);

  const [results, setResults] = useState(INITIAL_RESULTS);

  const handleInputChange = event => {
    const { name, value } = event.target;

    setFormInputs(prevInputs => ({
      ...prevInputs,
      [method]: {
        ...prevInputs[method],
        [name]: {
          ...prevInputs[method][name],
          value,
        },
      },
    }));
  };

  const calculateDisplacement = () => {
    const { sampleWeight, initialWaterLevel, submergedWaterLevel } = formInputs.displacement;
    const volume = Number(submergedWaterLevel.value) - Number(initialWaterLevel.value);
    const pfc = (Number(sampleWeight.value) / volume) * 62.438 || 0;

    setResults(prevResults => ({
      ...prevResults,
      displacement: {
        ...prevResults.displacement,
        initialLevel: {
          ...prevResults.displacement.initialLevel,
          values: {
            ml: initialWaterLevel.value,
          },
        },
        submergedLevel: {
          ...prevResults.displacement.submergedLevel,
          values: {
            ml: submergedWaterLevel.value,
          },
        },
        volume: {
          ...prevResults.displacement.volume,
          values: {
            ml: volume,
          },
        },
        weight: {
          ...prevResults.displacement.weight,
          values: {
            grams: sampleWeight.value,
          },
        },
        density: {
          ...prevResults.displacement.density,
          values: {
            pfc: pfc.toFixed(2),
            kgm3: (pfc * 16.018463).toFixed(2) || 0,
          },
        },
      },
    }));
  };

  const calculateCaliper = () => {
    const { sampleWeight, width, length, height } = formInputs.caliper;
    const pfc =
      Number(sampleWeight.value) / (Number(width.value) * Number(length.value) * Number(height.value)) / 0.2625 || 0;
    const kgm3 = pfc * 16.018463 || 0;

    setResults(prevResults => ({
      ...prevResults,
      caliper: {
        ...prevResults.caliper,
        foamCubeVolume: {
          ...prevResults.caliper.foamCubeVolume,
          values: {
            width: width.value,
            height: height.value,
            depth: length.value,
          },
        },
        weight: {
          ...prevResults.caliper.weight,
          values: {
            grams: sampleWeight.value,
          },
        },
        density: {
          ...prevResults.caliper.density,
          values: {
            pfc: pfc.toFixed(2),
            kgm3: kgm3.toFixed(2),
          },
        },
      },
    }));
  };

  const onCalculate = () => {
    if (method === 'displacement') {
      calculateDisplacement();
    } else {
      calculateCaliper();
    }
  };

  return {
    method,
    setMethod,
    formInputs,
    setFormInputs,
    results,
    handleInputChange,
    onCalculate,
  };
};

export default useDensityCalculator;
